import * as React from "react";

const NotificationDeleteIcon = (props: { color: string; onClick?: () => void }): JSX.Element => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 3 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={props.onClick}
            style={{ cursor: props.onClick ? "pointer" : "default" }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 4.75C9.30964 4.75 8.75 5.30964 8.75 6V6.25H15.25V6C15.25 5.30964 14.6904 4.75 14 4.75H10ZM16.75 6.25V6C16.75 4.48122 15.5188 3.25 14 3.25H10C8.48122 3.25 7.25 4.48122 7.25 6V6.25H4C3.58579 6.25 3.25 6.58579 3.25 7C3.25 7.41421 3.58579 7.75 4 7.75H5.25V18C5.25 19.5188 6.48122 20.75 8 20.75H16C17.5188 20.75 18.75 19.5188 18.75 18V7.75H20C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25H16.75ZM17.25 7.75H6.75V18C6.75 18.6904 7.30964 19.25 8 19.25H16C16.6904 19.25 17.25 18.6904 17.25 18V7.75ZM10 10.25C10.4142 10.25 10.75 10.5858 10.75 11V16C10.75 16.4142 10.4142 16.75 10 16.75C9.58579 16.75 9.25 16.4142 9.25 16V11C9.25 10.5858 9.58579 10.25 10 10.25ZM14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V16C14.75 16.4142 14.4142 16.75 14 16.75C13.5858 16.75 13.25 16.4142 13.25 16V11C13.25 10.5858 13.5858 10.25 14 10.25Z"
                fill={props.color}
            />
        </svg>
    );
};

export default NotificationDeleteIcon;
